<template>
  <div>
    <div class="page">
      <img src="@/assets/image/loginBg.jpg" class="modalBg" />

      <div class="login">
        <div style="display: flex; align-items: center">
          <span style="
              font-size: 20px;
              font-weight: bold;
              color: red;
              margin: 0 20px;
              font-size: 24px;
            ">客服电话: 400-133-5833</span>
        </div>
        <div class="userInfo" @click="goHome">返回首页</div>
        <div>
          <a :href="aHref" target="_blank" style="
              display: block;
              color: #fff;
              text-decoration: none;
              border: 1px solid #fff;
              border-radius: 5px;
              padding: 2px 10px;
              font-size: 20px;
            ">管理员登录</a>
        </div>
      </div>
      <div class="container">
        <div class="title">西藏自治区专业技术人员继续教育网络平台</div>
        <div class="main">
          <img src="@/assets/image/loginImg.png" class="loginImg" />
          <form class="loginForm" @submit.prevent="handleSubmit">
            <div class="formTitle">账号登录</div>
            <div class="form-group">
              <img class="icon" src="@/assets/image/login_icon1.png" />
              <input v-model="loginName" placeholder="请输入身份证号" required />
            </div>
            <div class="form-group" style="margin-bottom: 15px">
              <img class="icon1" src="@/assets/image/login_icon2.png" />
              <input type="password" autocomplete="new-password" v-model="password" placeholder="请输入密码" required />
            </div>
            <div class="editP">
              <div @click="showModal">账号注册</div>
              <div @click="openEdit">忘记密码?</div>
            </div>
            <button type="submit" class="login-button" style="margin-bottom: 5px">
              登录
            </button>
            <div class="modalDec">
              原用户首次登录时密码为身份证后六位，若登录时密码不正确，请点击【忘记密码】进行重置
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- <div class="contact1" @click="dialogVisible = true">联系我们</div> -->
    <!-- 联系我们弹框 -->
    <div class="contactUs" v-show="dialogVisible">
      <div class="contactBg" @click="dialogVisible = false"></div>
      <div class="contact">
        <img class="guanbi" @click="dialogVisible = false" src="@/assets/image/关闭.png" />
        <div class="title">联系我们</div>
        <img src="@/assets/image/1241755506357_.pic.jpg" style="width: 500px" />
        <div style="padding: 0 36px; box-sizing: border-box; padding-bottom: 40px">
          <div style="margin-bottom: 10px">联系电话: 4001335833</div>
          <div>工作时间: 工作日周一到周五 (9:30-13:00,15:30-18:00)</div>
        </div>
      </div>
    </div>
    <Register ref="registers"></Register>
    <EditPassword ref="EditPassword"></EditPassword>
    <Verify @success="success" :mode="'pop'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"></Verify>
  </div>
</template>

<script>
// 使用vux的 mapState需要引入
import * as userApi from "@/api/user";
import Register from "@/components/register.vue";
import EditPassword from "@/components/editPassword.vue";
import Test from "./test.vue";
import JSEncrypt from "jsencrypt";
const encryptor = new JSEncrypt();
import Verify from "@/components/verifition/Verify.vue";
export default {
  components: {
    Register,
    Test,
    EditPassword,
    Verify,
  },
  data() {
    return {
      dialogVisible: false,
      imgBigVisible: false,
      loginName: undefined,
      password: undefined,
      verificationCode: undefined,
      activeName: "name",
      phone: "",
      code: "",
      time: 60,
      showTime: false,
      captchaId: "",
      imageCode: "",
      aHref: window.origin + "/admin/#/",
      publicKey: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvHdaUj121trhuXVQNTuweOAQIIGk1DOMIsN2Wt4F0B9mLtDJslW6dWVz8A4u3mZ6Jhu4SizXXWq63mD6Xaq/yUC8NkH3GBS8XCClQqZ6eIJR8zKBNkrpRQMgo0apiRThoksGnd/1AE+vrgZZZ9g/1bhyn2KJ2bY6qZJGb56XyKFBv7zciZ6q/S3KJruClk5FccwFwtQbsegkAyZOm+3wXW/Z2gxywVZvdbh+12abkFusRI0EdwFJspC7gYakG9Ml1iPW4kYLr2hXK2RrTGOUAo7VwI/QkNkJqaybb/A5G1vuvNqZjpOSWZhCBcM2Iheo6NSk00MX1upwAHB6e8hpRQIDAQAB`,
    };
  },
  methods: {
    async success(captchaData) {
      let data = {};
      let res = null;
      // 使用jsencrypt库进行加密
      encryptor.setPublicKey(this.publicKey);
      if (this.activeName == "name") {
        data = {
          loginName: encryptor.encrypt(this.loginName),
          password: encryptor.encrypt(this.password),
          captchaData: captchaData,
        };
        res = await userApi.password_v2(data);
      }
      if (res.code == 200) {
        if (res.data.resCode == 618) {
          this.$message.error(res.data.resMsg);
          return;
        }
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        // 缓存用户token
        localStorage.setItem("token", res.data.userToken);
        setTimeout(() => {
          if (window.location.href.indexOf("sa.tiehouedu.com") > -1) {
            window.location.href = window.origin + "/xzzj/pc/#/";
          } else if (window.location.href.indexOf("xzzhuanji.cn/migrate") > -1) {
            window.location.href = window.origin + "/migrate/pc/#/";
          } else {
            window.location.href = window.origin + "/#/";
          }
        }, 50);
      } else {
        this.$message.error(res.msg);
      }
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    show() {
      this.imgBigVisible = true;
    },

    openEdit() {
      this.$refs.EditPassword.openRegister();
    },
    showModal() {
      this.$refs.registers.showModal();
    },
    async handleSubmit() {
      this.$refs.verify.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.contactUs {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 991;

  .contactBg {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  .contact {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    background: #fff;
    border-radius: 10px;
    z-index: 1;
    width: 500px;
    display: flex;
    flex-direction: column;
    font-size: 16px;

    .title {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      padding-top: 20px;
    }
  }
}

.contact1 {
  position: fixed;
  width: 20px;
  right: 20px;
  bottom: 20vh;
  background: #65a3ea;
  text-align: center;
  padding: 10px 2px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  z-index: 909;
}

.editP {
  padding: 0 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 15px;
  color: #fff;
  margin-bottom: 14px;

  div {
    cursor: pointer;
  }
}

.modalDec {
  padding: 0 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 13px;
  color: #fff;
}

.dec {
  margin-right: 80px;
}

.dec-title1 {
  font-size: 38px;
  color: #fff;
  margin-bottom: 10px;
}

.dec-title2 {
  width: 500px;
  font-size: 18px;
  color: #fff;
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.modalBg {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1;
}

.page {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 101;
}

.container {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: 900px;
  height: 620px;
  padding: 40px 60px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;

  // overflow: hidden;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #3a82f4;
    line-height: 40px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .main {
    position: relative;

    .loginImg {
      width: 912px;
      height: 530px;
      position: relative;
      transform: translate(-60px, -0px);
      border-radius: 8px;
    }

    .loginForm {
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(100px);
      width: 400px;
      height: 450px;
      background: #b0c4f8;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 30px 20px;

      .formTitle {
        font-size: 20px;
        color: #fff;
        margin-bottom: 20px;
      }
    }
  }
}

.form-group {
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .icon {
    width: 35px;
    height: 35px;
    position: absolute;
    left: 10px;
    top: 5px;
  }

  .icon1 {
    width: 25px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 9px;
  }

  .icon2 {
    width: 25px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 9px;
  }
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  margin-right: 10px;
}

.form-group button {
  width: 110px;
  padding: 8px;
  margin-left: 10px;
  border: none;
  font-size: 14px;
  background: linear-gradient(180deg, #f2ce31 0%, #ff9c00 100%);
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.form-group button:hover {
  background-color: #6da2da;
}

.login-button {
  width: 100%;
  height: 40px;
  background: #4a78ef;
  border-radius: 40px;
  border: none;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}

.form-group input {
  flex: 1;
  padding: 15px 20px;
  padding-left: 50px;
  border: none;
  background: #fff;
  border-radius: 40px;
}

.login {
  position: absolute;
  right: 5vw;
  top: 20px;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;

  .userInfo {
    display: flex;
    align-items: center;
    margin-right: 20px;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px 10px;
    font-size: 20px;

    .avatarUrl {
      width: 30px;
      height: 30px;
      border-radius: 30px;
    }

    .realName {
      margin-left: 10px;
      color: #fff;
    }
  }

  .loginItem {
    padding: 0 10px;
    font-size: 16px;
    color: #0d6fc2;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
